import { Component, EventEmitter, Input, Output } from '@angular/core';

export type ButtonStyle = 'primary' | 'secondary' | 'outline-dark' | 'outline-light';
export type ButtonHeight = 'x-small' | 'small' | 'medium' | 'large';
export type ButtonWidth = 'compact' | 'expanded' | 'full-width';
export type FontSize = 'small-font' | 'regular-font';
export type IconPosition = 'left' | 'right';
export type IconVariant = 'arrow' | 'add' | 'x' | 'remove' | 'refresh' | 'info';

@Component({
  selector: 'broker-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Input() id = '';
  @Input() style: ButtonStyle = 'primary';
  @Input() height: ButtonHeight = 'medium';
  @Input() width: ButtonWidth = 'expanded';
  @Input() fontSize: FontSize = 'regular-font';
  @Input() disabled = false;
  @Input() loading = false;
  @Input() icon: IconVariant = null;
  @Input() iconPosition: IconPosition = 'left';
  @Input() tooltip: string = undefined;
  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();
}
